import { Injectable } from "@angular/core";

import { of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';

import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ToastifyService } from "../../shared/toastify-service";
import { CommonAPIService } from "../../core/services/common-api.service";
import { buySubscription, buySubscriptionFailure, buySubscriptionSuccess, fetchSubscriptionPlans, fetchSubscriptionPlansFailure, fetchSubscriptionPlansSuccess, fetchSubscriptionVendorPlan, fetchSubscriptionVendorPlanFailure, fetchSubscriptionVendorPlanSuccess } from "./subscription.actions";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { TokenStorageService } from "../../core/services/token-storage.service";


@Injectable()
export class SubscriptionEffects {

    buySubscription$ = createEffect(() =>
        this.actions$.pipe(
            ofType(buySubscription),
            mergeMap(({ postdata }) =>
                this.commonApiService.buysubscription(postdata).pipe(
                    map(() => buySubscriptionSuccess()),
                    catchError((error) => of(buySubscriptionFailure({ error })))
                )
            )
        )
    );

    buySubscriptionSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(buySubscriptionSuccess),
                tap(action => {
                    this.toastifyService.showSuccessMessage("Enjoy! Subscription activated successfully");
                })
            ),
        { dispatch: false }
    );

    buySubscriptionFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(buySubscriptionFailure),
                tap((error: any) => {
                    this.toastifyService.showErrorMessage(error.error.message);
                })
            ),
        { dispatch: false }
    );

    //FETCH ALL SUBSCRIPTION PLANS
    fetchSubscriptionPlans$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchSubscriptionPlans),
            mergeMap(() =>
                this.afs.collection('sunnflyplans').doc('Yy5MBX5HuXuz2xAqjhDI')
                    .valueChanges().pipe(
                        map((docs: any) => {
                            console.log('docs-->', docs);
                            return fetchSubscriptionPlansSuccess({ subsriptionPlans: docs });
                        }),
                        catchError((error) =>
                            of(fetchSubscriptionPlansFailure({ error }))
                        )
                    )
            )
        )
    );

    fetchSubscriptionPlansFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(fetchSubscriptionPlansFailure),
                tap((error: any) => {
                    this.toastifyService.showErrorMessage(error.error.message);
                })
            ),
        { dispatch: false }
    );

    //FETCH VENDOR SUBSCRIPTION PLANS
    fetchSubscriptionVendorPlan$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchSubscriptionVendorPlan),
            mergeMap(() =>
                this.afs.collection('subscriptions').doc(this.tokenService.getUser().guid)
                    .valueChanges().pipe(
                        map((docs: any) => {
                            console.log('docs-->', docs);
                            return fetchSubscriptionVendorPlanSuccess({ subsriptionPlans: docs });
                        }),
                        catchError((error) =>
                            of(fetchSubscriptionVendorPlanFailure({ error }))
                        )
                    )
            )
        )
    );

    fetchSubscriptionVendorPlanFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(fetchSubscriptionVendorPlanFailure),
                tap((error: any) => {
                    this.toastifyService.showErrorMessage(error.error.message);
                })
            ),
        { dispatch: false }
    );

  constructor(
    private actions$: Actions,
    private commonApiService: CommonAPIService,
    private toastifyService: ToastifyService,
    private afs: AngularFirestore,
    private tokenService: TokenStorageService
  ) { }
}